













import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class ResetUserPasswordDialog extends VueExtendedBaseComponent {
  @Prop() private open!: boolean
  @Prop({ default: '' }) private email!: string

  private loading = false
  @Action('login/ForgetPasswordFunc')
  private postForgetData!: (data: {email?: string, phone?: string}) => string

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get resetUserPasswordDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'cancel',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'reset',
          action: this.resetUserPasswordAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  private async resetUserPasswordAction() {
    this.loading = true
    try {
      await this.postForgetData(
        {email: this.email},
      )
      this.updateSnackbar({txt: 'Sent mail for reset password success.', type: 'success'})
      this.loading = false
      this.closeDialog()
    } catch (error) {
      this.loading = false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
